import { useTheme } from "next-themes";
import { siteConfig } from "@/config/site.config";
import { RadioGroup, ActionIcon } from "rizzui";
import { updateThemeColor } from "@/utils/update-theme-color";
import { presetDark, presetLight } from "@/config/color-presets";
import { useEffect } from "react";
import { useColorPresetName } from "@/layouts/settings/use-theme-color";
import LightMode from "@/components/icons/light-mode";
import DarkMode from "@/components/icons/dark-mode";
import RadioBox from "@/layouts/settings/radio-box";
import DrawerBlock from "@/layouts/settings/drawer-block";
import { property } from "lodash";

const themeOptions = ["light", "dark"];

export default function ThemeSwitcher() {
    const { theme, setTheme } = useTheme();
    const { colorPresetName } = useColorPresetName();

    useEffect(() => {
        if (theme === "light" && colorPresetName === "black") {
            updateThemeColor(
                presetLight.lighter,
                presetLight.light,
                presetLight.default,
                presetLight.dark,
                presetLight.foreground,
            );
        }
        if (theme === "dark" && colorPresetName === "black") {
            updateThemeColor(
                presetDark.lighter,
                presetDark.light,
                presetDark.default,
                presetDark.dark,
                presetDark.foreground,
            );
        }
    }, [theme, colorPresetName]);

    const toggleTheme = () => {
        setTheme(theme === "light" ? "dark" : "light");
    };

    return (
        <ActionIcon
            onClick={toggleTheme}
            aria-label={theme === "light" ? "Switch to Dark Mode" : "Switch to Light Mode"}
            variant="text"
            className="relative h-[34px] w-[34px] shadow backdrop-blur-md dark:bg-gray-100 md:h-9 md:w-9 animate"
        >
            {theme === "light" ? (
            <LightMode aria-label="Light Mode" className="h-[18px] w-auto animate-pulse " />
            ) : (
            <DarkMode aria-label="Dark Mode" className="h-[18px] w-auto animate-pulse" />
            )}
        </ActionIcon>
    );
}
